import s from 'secure-ls';

export const secure = new s({ encodingType: 'aes', isCompression: false });
